<style lang="scss" scoped>
.step-title {
  position: relative;

  width: 4.7rem;
  height: 0.28rem;

  font-size: 0.28rem;
  line-height: 0.28rem;
  text-align: center;
  color: #a27d49;
  &:before {
    display: block;

    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);

    width: 1.66rem;
    height: 0.12rem;

    background: no-repeat url('../images/bg_stage_operation_title_left.png');

    content: '';
    background-size: contain;
  }
  &:after {
    display: block;

    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);

    width: 1.66rem;
    height: 0.12rem;

    background: no-repeat url('../images/bg_stage_operation_title_right.png');

    content: '';
    background-size: contain;
  }
}
</style>

<template>
  <div class="step-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
